import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

// React Router preserves scroll position across navigations, so moving between
// routes (header nav, footer links, in-content links, programmatic navigate)
// would leave the new page scrolled to wherever the previous one was. This
// global helper resets to the top on every route change and moves focus to the
// main content for keyboard / screen-reader users.
//
// In-page hash links (e.g. /services#tech-pathways) are intentionally left
// alone — the target page's own anchor-scroll effect handles those, so we don't
// fight it by yanking the view back to the top.
export default function ScrollToTop() {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    if (hash) return;
    // Instant jump (not smooth) — a route change should feel like a fresh page
    // load, not a long animated scroll.
    window.scrollTo({ top: 0, left: 0, behavior: 'auto' });
    // Focus the top of the content so the next Tab / screen-reader read starts
    // from the new page. preventScroll keeps the jump-to-top above from being
    // undone by the focus.
    const main = document.getElementById('main-content');
    if (main instanceof HTMLElement) {
      main.focus({ preventScroll: true });
    }
  }, [pathname, hash]);

  return null;
}
